<template>
    <v-dialog v-model="show" max-width="800" persistent no-click-animation>
        <div class="CriteriaConfigEditor">
            <div class="dialog-header">
                <div>{{ $f.tc('createCriteriaConfig') }}</div>
                <v-btn flat icon @click="close()">
                    <v-icon>close</v-icon>
                </v-btn>
            </div>
            <div style="padding: 0 12px 12px 12px">
                <!--List config-->
                <div style="height: 353px; overflow-y: auto; padding-top:12px;" class="fci-scrollbar">
                    <!--Table config-->
                    <SimpleDataTable
                        :headers="headers"
                        :items="configs"
                        :hide-pager="true"
                    >
                        <template v-slot:value="props">
                            <v-textarea
                                :rows="2"
                                v-model="props.item.value"
                                class="textarea-custom"
                                readonly
                            ></v-textarea>
                        </template>
                        <template v-slot:description="props">
                            <v-textarea
                                v-if="props.item.value === editConfig.value"
                                :rows="2"
                                v-model="editConfig.description"
                                class="textarea-custom"
                            ></v-textarea>
                            <v-textarea
                                v-else
                                v-model="props.item.description"
                                class="textarea-custom"
                                :rows="2"
                                readonly
                            ></v-textarea>
                        </template>
                        <template v-slot:action="props">
                            <div v-if="props.item.value === editConfig.value" class="centerXY">
                                <div class="btn-icon mr-6" @click="closeEdit"
                                     style="margin: 0!important">
                                    <img src="/img/close.svg" alt="icon-config"
                                         style="transform: scale(1.1)">
                                </div>
                                <div class="btn-icon" @click="saveEdit(props.item)"
                                     style="margin: 0!important">
                                    <img src="/img/save-member-2.svg" alt="icon-config"
                                         style="transform: scale(0.9)">
                                </div>
                            </div>
                            <div v-else class="centerXY">
                                <div class="btn-icon mr-6" @click="editCriteriaItem(props.item)"
                                     style="margin: 0!important">
                                    <img src="/img/edit-2.svg" alt="icon-edit"
                                         style="transform: scale(0.9)">
                                </div>
                                <div class="btn-icon" @click="deleteConfig(props.item)" style="margin: 0!important">
                                    <img src="/img/delete-member.svg" alt="icon-delete"
                                         style="transform: scale(0.9); padding-left: 1px">
                                </div>
                            </div>
                        </template>
                    </SimpleDataTable>

                    <!--Add new config-->
                    <div
                        class="btn-custom-normal btn-add"
                        @click="handleClickAddNew"
                        v-show="!isShowAddItem"
                    >
                        <img src="/img/add-member.svg" alt="icon-add" style="padding-right: 6px">
                        {{ $f.tc('addNew') }}
                    </div>

                    <!--New config-->
                    <v-form v-show="isShowAddItem" class="table-add-member" v-model="formValid" ref="form">
                        <div class="item-new-member">
                            <v-textarea
                                v-model="newConfig.value"
                                class="textarea-custom"
                                :rows="2"
                                :rules="formRules.required"
                                ref="NewCriteriaName"
                            ></v-textarea>
                        </div>
                        <div class="item-new-member">
                            <v-textarea
                                v-model="newConfig.description"
                                class="textarea-custom"
                                :rows="2"
                            ></v-textarea>
                        </div>
                        <div class="item-new-member centerXY" @click="submit">
                            <div @click="cancelAddConfig" class="btn-icon mr-6">
                                <img src="/img/close.svg" alt="icon-config" style="transform: scale(1.3)">
                            </div>
                            <div class="btn-icon">
                                <img src="/img/save-member-2.svg" alt="icon-save" style="transform: scale(0.9);">
                            </div>
                        </div>
                    </v-form>
                </div>
            </div>
            <div class="dialog-footer justify-center">
                <div class="btn-primary btn-back mr-8" @click="closeDialog">
                    {{ $f.tc('back') }}
                </div>
                <div class="btn-primary" @click="closeDialog">
                    {{ $f.tc('done') }}
                </div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import DialogPromiseFormMixin from '@/modules/fptai/mixins/DialogPromiseFormMixin'
import SimpleDataTable from '@/components/SimpleDataTable'
import QcCampaignService from '@/services/qc.campaign.service'

const defaultConfig = {
    value: '',
    description: ''
}

export default {
    name: 'CriteriaConfigEditor',
    components: { SimpleDataTable },
    mixins: [DialogPromiseFormMixin],
    props: {
        isQCSentence: {
            type: Boolean,
            default: false,
        }
    },
    data () {
        return {
            qcCampaignId: '',
            criteriaId: '',
            configs: [],
            itemToDelete: false,
            isShowAddItem: false,
            newConfig: this.$utils.cloneObject(defaultConfig),
            editConfig: {},
            editConfigIndex: -1,
            itemService: QcCampaignService.CriteriaService,
            changeConfig: false,
            defaultValue: '',
        }
    },
    computed: {
        headers () {
            return [
                {
                    text: this.$f.tc('value'),
                    value: 'value',
                    type: 'custom',
                    id: 'value'
                },
                {
                    text: this.$f.tc('description'),
                    value: 'description',
                    type: 'custom',
                    id: 'description'
                },
                {
                    text: '',
                    value: 'action',
                    sortable: false,
                    type: 'custom',
                    id: 'action'
                }
            ]
        }
    },
    methods: {
        open (qcCampaignId, criteriaId) {
            this.qcCampaignId = qcCampaignId
            this.criteriaId = criteriaId
            this.show = true
            this.isShowAddItem = false
            this.$refs.form.resetValidation()
            this.itemService = this.isQCSentence ? QcCampaignService.ASRCriteriaService : QcCampaignService.CriteriaService
            this.getConfig()

            return new Promise((resolve, reject) => {
                this.promise = { resolve, reject }
            })
        },
        submit (event) {
            if (event) {
                event.preventDefault()
            }

            if (this.formValid) {
                this.addConfig()
            } else {
                this.$refs.form.validate()
            }
        },
        addConfig () {
            this.$appService.showLoading()
            this.configs.push(this.newConfig)
            this.itemService.update(this.qcCampaignId, this.criteriaId, {
                config: JSON.stringify(this.configs)
            }).then(() => {
                this.updateConfigEnum(true)
            }).catch(()=>{
                this.configs.pop()
            }).finally(() => {
                this.newConfig = this.$utils.cloneObject(defaultConfig)
                this.isShowAddItem = false
                this.$refs.form.reset()
                this.$appService.hideLoading()
            })
        },
        getConfig () {
            if (this.qcCampaignId || this.criteriaId) {
                this.$appService.showLoading()
                this.itemService.read(this.qcCampaignId, this.criteriaId).then(result => {
                    this.defaultValue = result.data?.default_value || ''
                    if (result.data.config) {
                        this.configs = JSON.parse(result.data.config)
                    }
                }).finally(this.$appService.hideLoading)
            }
        },
        cancelAddConfig () {
            this.isShowAddItem = false
            this.$refs.form.resetValidation()
            this.model = this.$utils.cloneObject(defaultConfig)
        },
        deleteConfig (item) {
            if (item.value === this.defaultValue) {
                this.$appService.toastWarning(this.$f.tc('changeDefaultValue'))
                return
            }
            let deleteMessage = this.$f.tc('delete') + ' ' + this.$t('config') + ' ' + item.value
            this.$appService.confirm(deleteMessage).then(
                confirm => {
                    if (confirm) {
                        let indexToDelete = this.configs.findIndex(config => config.value === item.value)
                        if (indexToDelete > -1) {
                            this.configs.splice(indexToDelete, 1)
                        }
                        this.$appService.showLoading()
                        this.itemService.update(this.qcCampaignId, this.criteriaId, {
                            config: JSON.stringify(this.configs)
                        }).then(() => {
                            this.updateConfigEnum(true)
                        }).finally(() => {
                            this.$appService.hideLoading()
                        })
                    }
                }
            )
        },
        closeDialog () {
            this.close()
        },
        closeEdit () {
            this.editConfig = Object.assign({}, {})
            this.editConfigIndex = -1
        },
        saveEdit (item) {
            if (JSON.stringify(this.editConfig) === JSON.stringify(item)) {
                this.closeEdit()
            }
            if (this.editConfigIndex > -1) {
                this.configs[this.editConfigIndex] = this.editConfig
                this.itemService.update(this.qcCampaignId, this.criteriaId, {
                    config: JSON.stringify(this.configs)
                }).then(result => {
                    this.updateConfigEnum(true)
                    this.defaultValue = result.data?.default_value || ''
                    if (result.data.config) {
                        this.configs = JSON.parse(result.data.config)
                    }
                }).finally(() => {
                    this.$appService.hideLoading()
                })
            }
            this.closeEdit()
        },
        editCriteriaItem (item) {
            this.editConfigIndex = this.configs.indexOf(item)
            this.editConfig = Object.assign({}, item)
        },
        handleClickAddNew () {
            this.isShowAddItem = true
            this.$nextTick(() => {
                this.$refs.NewCriteriaName.focus()
            })
        },
        updateConfigEnum (data) {
            this.$emit('isChangeEnumConfig', data)
        }
    }
}
</script>

<style scoped lang="scss">
.CriteriaConfigEditor {
    background: #FFFFFF;
    position: relative;
    overflow: hidden;

    .dialog-header {
        padding: 0 0 0 12px;
    }

    .label {
        margin-top: 12px;
        font-family: "open sans semi", serif;
        font-size: 13px;
    }

    .btn-custom-normal {
        height: 40px !important;
        border-radius: 0 !important;
        justify-content: left;
        color: #0052CC;
        font-size: 14px;
        font-family: "open sans bold", serif;
        font-style: normal;
        text-align: center;
    }
}

.textarea-custom {
    position: relative;

    ::v-deep {
        .v-input__slot {
            background: #FFFFFF;
            border-radius: 0;
            outline: none;
            font-size: 12px;
            margin: 0;
            padding: 0 !important;
            display: flex;
            align-items: center;
            position: relative;

            textarea {
                padding: 15px 0 6px 0;
                overflow-y: auto;
                height: 50px;
                margin: 0 !important;
                color: black;
            }

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 50px;
            background: #FFFFFF;
            border-radius: 0;
            border: none !important;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }
        }

        .v-label {
            background: #FFFFFF !important;
            padding: 0 6px;

            &:not(.v-label--active) {
                font-size: 14px !important;
                padding-left: 0 !important;
            }
        }
    }
}

.btn-add {
    height: 49px !important;
    border-radius: 0 !important;
    justify-content: left;
    color: #0052CC;
    font-size: 14px;
    font-family: "open sans bold", serif;
    font-style: normal;
    text-align: center;
    border-top: none;
}

.table-add-member {
    border: 1px solid #DADFEC;
    border-top: none;
    display: flex;

    .item-new-member {
        height: 50px;
        border-right: 1px solid #DADFEC;

        &:last-child {
            border-right: none;
        }

        &:nth-child(1) {
            position: relative;
            margin: 0 !important;
            width: 201px;
        }

        &:nth-child(2) {
            margin: 0 !important;
            width: 500px;
        }

        &:nth-child(3) {
            flex: 1;
            margin: 0 !important;
            text-align: center;
        }
    }
}

::v-deep {
    .v-text-field {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }


    .v-text-field__details {
        position: absolute;
        right: 10px !important;
        top: 18px !important;
    }

    .v-table__overflow {
        width: 100%;
        font-size: 14px;
        font-family: "open sans", serif !important;
        border: 1px solid #DADFEC;
        border-collapse: collapse;
        border-spacing: 0;

        thead tr:not(.v-datatable__progress) {
            height: 40px !important;
            border-bottom: none;
            padding: 0 !important;

        }

        thead tr th {
            text-transform: capitalize !important;
            color: #12274F !important;
            background: #F4F7FE;
            border-right: 1px solid #DADFEC;
            padding: 0 10px;

            &:last-child {
                border-right: none;
            }

            &:nth-child(1) {
                width: 200px;
            }

            &:nth-child(2) {
                width: 500px;
            }

            &:nth-child(3) {
                flex: 1;
            }
        }

        tbody tr td {
            height: 40px !important;
            border-right: 1px solid #DADFEC;
            padding: 0 10px;
            border-top: 1px solid #DADFEC;

            &:last-child {
                border-right: none;
            }

            &:nth-child(1) {
                width: 200px;
                padding: 0 !important;
            }

            &:nth-child(2) {
                width: 500px;
                padding: 0;
            }

            &:nth-child(3) {
                flex: 1;
                padding: 0;
            }
        }
    }

    .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
        background: #FFFFFF;
    }

    textarea {
        padding: 10px !important;
        overflow-y: auto;
        margin: 0 !important;
        font-size: 14px;

        &::-webkit-scrollbar {
            width: 7px;
            height: 10px;
            background-color: transparent;
            border: none;
        }

        &::-webkit-scrollbar-track {
            background-color: transparent;
            border: none;
        }

        &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background: rgba(0, 0, 0, 0.1);
            border: none;
        }

        &::-webkit-scrollbar-thumb:hover {
            background: rgba(0, 0, 0, 0.5);
        }
    }
}
</style>
